import { render, staticRenderFns } from "./AboutOne.vue?vue&type=template&id=18d90782"
import script from "./AboutOne.vue?vue&type=script&lang=js"
export * from "./AboutOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports